import { addNewRelicPageAction } from 'ddc-new-relic';
import logger from 'ws-scripts/modules/logger';

import { NR_LOGGING_ATTR_PREFIX } from '../constants';

export const errorBoundaryHandler = (error, errorInfo) => {
	logger.error(
		`${NR_LOGGING_ATTR_PREFIX}-error-boundary:\n${error}\n${errorInfo.componentStack}`
	);
};

export const formSubmitNRTracking = (year, make, model, trimName) => {
	addNewRelicPageAction(`${NR_LOGGING_ATTR_PREFIX}-form-submited-tracking`, {
		year,
		make,
		model,
		trim: trimName
	});
};
